import { css } from '@microsoft/fast-element';
import { display } from '@microsoft/fast-foundation';
export const DesignSystemProviderStyles = css `
  ${display('block')};
`;
